// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_ServiceFiscalRemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/service_fiscal/remover
 *
 * Returns null dados on success.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type So_ServiceFiscalRemoverResponseDados = null;

export type So_ServiceFiscalRemoverResponse = ApiResponse<So_ServiceFiscalRemoverResponseDados>;

registerResponseContract('So_ServiceFiscalRemoverResponse', {})
